import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import { locale, setLocale, syncUserLocale } from '@/i18n'
import { paymentReturnLanguage } from '@/utils/paymentReturn'

// страницы
import LandingPage from '@/views/LandingPage.vue'
import DashboardPage from '@/views/DashboardPage.vue'
import ForgotPasswordPage from '@/views/ForgotPasswordPage.vue'
import LoginPage from '@/views/LoginPage'
import PasswordRecoveryPage from '@/views/PasswordRecoveryPage.vue'
import ResetPasswordPage from '@/views/ResetPasswordPage.vue'
import PersonalAccount from '@/views/PersonalAccount.vue'
import PersonalSecurity from '@/views/PersonalSecurity.vue'
import PersonalObjects from '@/views/PersonalObjects.vue'
import PersonalFonts from '@/views/PersonalFonts.vue'
import PersonalSubscription from '@/views/PersonalSubscription.vue'
import MyProcessings from '@/views/MyProcessings.vue'
import SubscriptionPlans from '@/views/SubscriptionPlans.vue'
import SubscriptionPayment from '@/views/SubscriptionPayment.vue'
import PaymentReturn from '@/views/PaymentReturn.vue'
import CreditsPayment from '@/views/CreditsPayment.vue'
import ProjectsPage from '@/views/ProjectsPage.vue'
import RegisterPage from '@/views/RegisterPage'
import SuccessRegisterPage from '@/views/SuccessRegisterPage.vue'
import SuccessEmailVerificationPage from "@/views/SuccessEmailVerificationPage.vue";
import AdminDashboard from '@/views/admin/AdminDashboard.vue'
import AdminCategories from '@/views/admin/AdminCategories.vue'
import AdminSubcategories from '@/views/admin/AdminSubcategories.vue'
import AdminElements from '@/views/admin/AdminElements.vue'
import AdminUsers from '@/views/admin/AdminUsers.vue'
import AdminBackgrounds from '@/views/admin/AdminBackgrounds.vue'
import AdminSettings from '@/views/admin/AdminSettings.vue'
import AdminLogs from '@/views/admin/AdminLogs.vue'
import AdminAmbassadors from '@/views/admin/AdminAmbassadors.vue'
import AdminPayments from '@/views/admin/AdminPayments.vue'
import PartnerProgram from '@/views/PartnerProgram.vue'
import TermsOfService from '@/views/TermsOfService.vue'
import ContactsPage from '@/views/ContactsPage.vue'
import RefundPolicy from '@/views/RefundPolicy.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import PersonalDataConsent from '@/views/PersonalDataConsent.vue'

const routes = [
        {
                path: '/',
                name: 'Landing',
                component: LandingPage,
                meta: { locale: 'ru' },
        },
        {
                path: '/en',
                name: 'LandingEn',
                component: LandingPage,
                meta: { locale: 'en' },
        },
        { path: '/terms', component: TermsOfService, name: 'Terms' },
        { path: '/contacts', component: ContactsPage, name: 'Contacts' },
        { path: '/refund-policy', component: RefundPolicy, name: 'RefundPolicy' },
        { path: '/privacy-policy', component: PrivacyPolicy, name: 'PrivacyPolicy' },
        { path: '/personal-data-consent', component: PersonalDataConsent, name: 'PersonalDataConsent' },
        { path: '/login', component: LoginPage, meta: { locale: 'ru' } },
        { path: '/register', component: RegisterPage, meta: { locale: 'ru' } },
        {
                path: '/password-recovery',
                component: PasswordRecoveryPage,
                meta: { locale: 'ru' },
                beforeEnter: (to, from, next) => {
                        if (!to.query.token) {
                                return next('/login')
                        }
                        next()
                }
        },
        { path: '/forgot-password', component: ForgotPasswordPage, meta: { locale: 'ru' } },
        { 
                path: '/reset-password/:token', 
                component: ResetPasswordPage,
                name: 'ResetPassword',
                meta: { locale: 'ru' },
        },
        {
                path: '/success-register',
                name: 'SuccessRegister',
                component: SuccessRegisterPage,
                meta: { locale: 'ru' },
        },
        {
                path: '/success-verification',
                name: 'SuccessVerification',
                component: SuccessEmailVerificationPage,
                meta: { locale: 'ru' },
        },
        {
                path: '/en/login',
                name: 'LoginEn',
                component: LoginPage,
                meta: { locale: 'en' },
        },
        {
                path: '/en/register',
                name: 'RegisterEn',
                component: RegisterPage,
                meta: { locale: 'en' },
        },
        {
                path: '/en/forgot-password',
                name: 'ForgotPasswordEn',
                component: ForgotPasswordPage,
                meta: { locale: 'en' },
        },
        {
                path: '/en/password-recovery',
                name: 'PasswordRecoveryEn',
                component: PasswordRecoveryPage,
                meta: { locale: 'en' },
                beforeEnter: (to, from, next) => {
                        if (!to.query.token) {
                                return next('/en/login')
                        }
                        next()
                }
        },
        {
                path: '/en/reset-password/:token',
                name: 'ResetPasswordEn',
                component: ResetPasswordPage,
                meta: { locale: 'en' },
        },
        {
                path: '/en/success-register',
                name: 'SuccessRegisterEn',
                component: SuccessRegisterPage,
                meta: { locale: 'en' },
        },
        {
                path: '/en/success-verification',
                name: 'SuccessVerificationEn',
                component: SuccessEmailVerificationPage,
                meta: { locale: 'en' },
        },
        {
                path: '/dashboard',
                name: 'Dashboard',
                redirect: '/projects',
                meta: { requiresAuth: true },
        },
        {
                path: '/projects',
                name: 'Projects',
                component: ProjectsPage,
                meta: { requiresAuth: true },
        },
        {
                path: '/projects/:projectId',
                name: 'ProjectConstructor',
                component: DashboardPage,
                props: route => ({ projectId: route.params.projectId }),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                        if (!to.params.projectId) {
                                return next('/projects')
                        }
                        next()
                },
        },
        {
                path: '/personal-account',
                component: PersonalAccount,
                meta: { requiresAuth: true },
        },
        {
                path: '/personal-security',
                component: PersonalSecurity,
                meta: { requiresAuth: true },
        },
        {
                path: '/personal-objects',
                component: PersonalObjects,
                meta: { requiresAuth: true },
        },
        {
                path: '/my-objects',
                component: PersonalObjects,
                meta: { requiresAuth: true },
        },
        {
                path: '/my-fonts',
                component: PersonalFonts,
                meta: { requiresAuth: true },
        },
        {
                path: '/personal-subscription',
                component: PersonalSubscription,
                meta: { requiresAuth: true },
        },
        {
                path: '/my-processings',
                component: MyProcessings,
                meta: { requiresAuth: true },
        },
        {
                path: '/subscription/plans',
                component: SubscriptionPlans,
                meta: { requiresAuth: true },
        },
        {
                path: '/subscription/payment',
                component: SubscriptionPayment,
                meta: { requiresAuth: true },
        },
        {
                path: '/payment/return',
                component: PaymentReturn,
                meta: { requiresAuth: true },
        },
        {
                path: '/credits/payment',
                component: CreditsPayment,
                meta: { requiresAuth: true },
        },
        {
                path: '/partner-program',
                component: PartnerProgram,
                meta: { requiresAuth: true },
        },
        {
                path: '/admin',
                component: AdminDashboard,
                meta: { requiresAuth: true, requiresAdmin: true },
                children: [
                        {
                                path: 'categories',
                                component: AdminCategories
                        },
                        {
                                path: 'subcategories/:categoryId',
                                component: AdminSubcategories
                        },
                        {
                                path: 'elements',
                                component: AdminElements
                        },
                        {
                                path: 'users',
                                component: AdminUsers
                        },
                        {
                                path: 'backgrounds',
                                component: AdminBackgrounds
                        },
                        {
                                path: 'settings',
                                component: AdminSettings
                        },
                        {
                                path: 'logs',
                                component: AdminLogs
                        },
                        {
                                path: 'ambassadors',
                                component: AdminAmbassadors
                        },
                        {
                                path: 'payments',
                                component: AdminPayments
                        }
                ]
        },
]

const router = createRouter({
        history: createWebHistory(),
        routes,
})

router.beforeEach(async (to, from, next) => {
        const returnLanguage = paymentReturnLanguage(to)
        if (to.meta.locale) {
                setLocale(to.meta.locale)
        } else if (returnLanguage) {
                setLocale(returnLanguage)
        }
        const loginTarget = {
                path: locale.value === 'en' ? '/en/login' : '/login',
                ...(to.path === '/payment/return' ? { query: { redirect: to.fullPath } } : {}),
        }

        const isAuthenticated = store.getters['auth/isAuthenticated']
        if (to.matched.some(record => record.meta.requiresAuth)) {
                if (!isAuthenticated) {
                        return next(loginTarget)
                }
                if (!store.state.auth.user) {
                        try {
                                await store.dispatch('auth/loadUser')
                                await store.dispatch('ui/initAvatarSrcFromUser')
                        } catch (e) {
                                console.error('Ошибка при загрузке пользователя:', e)
                                return next(loginTarget)
                        }
                }
                syncUserLocale(store.state.auth.user)
                if (returnLanguage) setLocale(returnLanguage)
        }

        if (to.matched.some(record => record.meta.requiresAdmin)) {
                const user = store.state.auth.user
                if (!user || user.role !== 'admin') {
                        return next('/')
                }
        }

        next()
})

export default router
